import { cn } from "@/lib/utils";

/** Iamu brand glyph — cobalt tile with tri-plane origami crane fold */
export function IamuGlyph({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn("shrink-0", className)}
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="8" fill="#1564b8" />
      {/* Facet 1: Top Wing (dominant highlight plane) */}
      <polygon points="7,8 25,11 17,21" fill="#ffffff" fillOpacity="0.98" />
      {/* Facet 2: Lower Fold (shadow keel plane) */}
      <polygon points="7,8 17,21 10,25" fill="#ffffff" fillOpacity="0.48" />
      {/* Facet 3: Right Return (midtone winglet plane) */}
      <polygon points="25,11 23,23.5 17,21" fill="#ffffff" fillOpacity="0.78" />
    </svg>
  );
}

export function IamuWordmark({
  className,
  showGlyph = true,
}: {
  className?: string;
  showGlyph?: boolean;
}) {
  return (
    <span className={cn("inline-flex items-center gap-2", className)}>
      {showGlyph && <IamuGlyph className="h-5 w-5 shadow-xs" />}
      <span className="text-lg font-bold tracking-tight">iamu</span>
    </span>
  );
}
